import { ROLES_PREMISSAS_VISUALIZACAO } from "./departamentosOrcamento";

// Premissas de Faturamento: leitura ampla (ROLES_PREMISSAS_VISUALIZACAO); edição só admin (ver
// isAdmin em pages/GestaoOrcamentaria/premissasFaturamento.js).
// Espelha backend/config.py ROLES_PREMISSAS_FATURAMENTO — mantenha os dois em sincronia.
export const ROLES_PREMISSAS_FATURAMENTO = ROLES_PREMISSAS_VISUALIZACAO;
